import { Editor } from 'slate';

import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { VOCAB_CARD } from '../../../BlogEditor/plugins/CardLogic/model/constants';

const NODE_TYPE = [VOCAB_CARD];
export const DisableEnterPlugin = (isDisableEnter = false): SlatePlugin => {
  return {
    onKeyDown: (e, editor) => {
      if (e.keyCode === 13) {
        if (isDisableEnter) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        const [node] = Editor.nodes(editor, {
          at: editor.selection,
          match: (n: any) => NODE_TYPE.includes(n?.type),
        });
        if (node) {
          e.preventDefault();
          e.stopPropagation();
        }
      }
    },
  };
};
